import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import Branding from 'domain/entity/branding';
import ReadBrandingClient from 'use-case/branding/read/readBrandingClient';
import ReadBrandingCriteria from 'use-case/branding/read/readBrandingCriteria';

const readBrandingApiClient = (httpClient: httpClientFunction, baseUrl: string): ReadBrandingClient => (criteria: ReadBrandingCriteria) =>
    httpClient(`${baseUrl}/brandings/${criteria.brandingId}`, {})
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asBranding)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asBranding = (brandingJson: BrandingJson) => new Branding(brandingJson.color.primary, brandingJson.color.background);

export type BrandingJson = {
    color: {
        primary: string;
        background: string;
    };
};

export default readBrandingApiClient;
